import {Component, input} from '@angular/core';
import {ButtonModule} from "primeng/button";
import {RouterLink} from "@angular/router";
import type {ButtonDesignTokens} from '../../types/button-design-tokens';

@Component({
  selector: 'homey-details-button',
  standalone: true,
  imports: [
    ButtonModule,
    RouterLink
  ],
  templateUrl: './details-button.component.html',
  styleUrl: './details-button.component.scss'
})
export class DetailsButtonComponent {
  public readonly link = input.required<string[]>();

  protected readonly buttonDt: ButtonDesignTokens = {
    colorScheme: {
      light: {
        text: {
          secondary: {
            color: '{surface.400}',
          },
        },
      },
    },
  };
}
